module.exports = __webpack_public_path__ + "static/img/star_person_service.1e33f245.png";